import SESSION_TYPE_COLORS from "components/Dashboard/utility/constants/session-type-colors";
import styles from "./SessionTypeColorEditor.module.scss";
import getClasses from "utils/getClasses";
import { Tooltip } from "react-bootstrap";
import OverlayTrigger from "components/overlay-trigger/OverlayTrigger";

interface SessionTypeColorSelectorProps {
  selectedColorLabel?: string;
  onChange: (colorId: string) => void;
}

const SessionTypeColorSelector = ({
  selectedColorLabel,
  onChange,
}: SessionTypeColorSelectorProps) => {
  const selectedColor =
    SESSION_TYPE_COLORS.find((color) => color.id === selectedColorLabel) ??
    SESSION_TYPE_COLORS[0];
  return (
    <div className={styles["container"]}>
      {SESSION_TYPE_COLORS.map((color, i) => (
        <OverlayTrigger
          key={color.id}
          placement="top"
          overlay={
            <Tooltip
              id="hide-from-public-view-tooltip"
              className={styles["hide-from-public-view__tooltip"]}
            >
              {color.name}
            </Tooltip>
          }
        >
          <div
            role="button"
            className={getClasses(
              styles["option-wrapper"],
              selectedColor.id === color.id &&
                styles["option-wrapper--selected"],
            )}
          >
            <div
              className={getClasses(
                styles["option-swatch"],
                i === 0 && styles["option-swatch--with-border"],
              )}
              style={{ backgroundColor: color.value }}
              onClick={() => onChange(color.id)}
            />
          </div>
        </OverlayTrigger>
      ))}
    </div>
  );
};

export default SessionTypeColorSelector;
